document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".faq-toggle");

  buttons.forEach((btn) => {
    btn.addEventListener("click", function () {
      const content = this.nextElementSibling;
      const isActive = this.classList.contains("active");

      // Cerrar todos
      buttons.forEach((b) => {
        b.classList.remove("active");
        b.nextElementSibling.style.maxHeight = null;
      });

      // Si el que clicaste no estaba activo, lo abrimos
      if (!isActive) {
        this.classList.add("active");
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
});
